import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Platform } from 'react-native';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { AnimatedImageView } from '../Image/AnimatedImageView';
import { AnimatedPressable } from '../Buttons/AnimatedPressable';
import { useAnimation } from '../Animations/AnimationHooks';
export const HeaderButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.headerButton,
    style(theme, mediaQuery, window, props) {
        return {
            container: Object.assign(Object.assign({ width: 16, height: 16, marginEnd: 20 }, Platform.select({
                web: {
                    marginStart: 20,
                    marginEnd: 10
                }
            })), props.containerStyle)
        };
    }
})(({ canGoBack, tintColor, hitSlop, forceShow: forceCanBack, icon, image, style, assets, isDismissButton, onPress: onDismiss }) => {
    var _a, _b, _c, _d;
    const [opacity, setOpacity] = useAnimation({ initialValue: 1, duration: 150 });
    const handleBack = useCallback(() => {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(canGoBack);
        setOpacity(0.6).then(() => setOpacity(1));
    }, [onDismiss]);
    const onMouseEnter = useCallback(() => setOpacity(0.6), []);
    const onMouseLeave = useCallback(() => setOpacity(1), []);
    if (!canGoBack && !forceCanBack) {
        return null;
    }
    return (_jsx(AnimatedPressable, { onPress: handleBack, style: Object.assign({ opacity }, Platform.select({ default: {}, web: { padding: 10, margin: -10 } })), hitSlop: hitSlop || 10, onMouseEnter, onMouseLeave, children: _jsx(AnimatedImageView, { containerStyle: style === null || style === void 0 ? void 0 : style.container, imageStyle: { tintColor }, color: tintColor, image: image || (isDismissButton
                ? (_a = assets === null || assets === void 0 ? void 0 : assets.images) === null || _a === void 0 ? void 0 : _a.close_url
                : (_b = assets === null || assets === void 0 ? void 0 : assets.images) === null || _b === void 0 ? void 0 : _b.back_url), icon: icon || (isDismissButton
                ? ((_c = assets === null || assets === void 0 ? void 0 : assets.images) === null || _c === void 0 ? void 0 : _c.close_icon) || 'si-close-cancel'
                : ((_d = assets === null || assets === void 0 ? void 0 : assets.images) === null || _d === void 0 ? void 0 : _d.back_icon) || 'si-arrow-left') }) }));
});
